import type { ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'
import { InputAdornment, MuiIconButton, TextField } from './generic.tsx'
import { Icon } from './Icon.tsx'

type SearchFieldProps = Omit<ComponentProps<typeof TextField>, 'value' | 'onChange' | 'slotProps' | 'select' | 'multiline'> & {
	value: string
	onChange: (value: string) => void
	onClear?: () => void
	alwaysShowClear?: boolean
	clearDataTa?: string
	leadingIcon?: boolean
}

export const SearchField = ({
	value,
	onChange,
	onClear,
	alwaysShowClear = false,
	clearDataTa,
	leadingIcon = false,
	placeholder,
	size,
	...props
}: SearchFieldProps) => {
	const { t } = useTranslation()
	const showClear = alwaysShowClear || value !== ''
	return (
		<TextField
			fullWidth
			size={size}
			placeholder={placeholder ?? t(($) => $.searchPlaceholder)}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			{...props}
			slotProps={{
				input: {
					startAdornment: leadingIcon ? (
						<InputAdornment position='start'>
							<Icon name='MagnifyingGlass' fontSize={size === 'small' ? 'small' : undefined} />
						</InputAdornment>
					) : undefined,
					endAdornment: showClear ? (
						<InputAdornment position='end'>
							<MuiIconButton data-ta={clearDataTa} edge='end' aria-label={t(($) => $.clear)} onClick={onClear ?? (() => onChange(''))}>
								<Icon name='CircleXmark' />
							</MuiIconButton>
						</InputAdornment>
					) : undefined,
				},
			}}
		/>
	)
}
